import _ from 'lodash';

export default class Base {
  constructor() {}

  /**
   * Override the attributes with the given ones
   * @param {Object} attributes
   */
  setAttributes(attributes) {
    _.forEach(attributes, (value, key) => {
      this.setAttribute(key, value);
    });
  }

  /**
   * Sets the Parse Object
   * @param po
   */
  setParseObject(po) {
    this['className'] = po.className;
    this['parseObject'] = po;
  }

  _init(obj) {
    _.forEach(Object.keys(obj), (key) => {
      if (!this.parseObject.get(key)) {
        this.parseObject.set(key, obj[key]);
      }
    });

    _.forEach(Object.keys(obj), (key) => {
      Object.defineProperty(this, key, {
        get() {
          return this.parseObject.get(key);
        },
        set(v) {
          this.parseObject.set(key, v);
        },
      });
    });
  }

  /**
   * @param {String} key
   * @param {*} value
   */
  setAttribute(key, value) {
    this[key] = value;
  }

  toJSON() {
    return this.parseObject.toJSON();
  }

  save() {
    return this.parseObject.save();
  }

  destroy() {
    return this.parseObject.destroy();
  }

  static collection() {
    throw new Error('collection method not implemented');
  }
}
